import s from 'Njangy/app/[lang]/home/shared/section/styles.module.css';
import { ReactNode } from 'react';

export type SectionProps = {
  id: string;
  testId: string;
  children: ReactNode;
};

export const Section = ({ id, testId, children }: SectionProps) => (
  <section className={s.root} data-testid={testId} id={id}>
    <div className={s.wrap}>{children}</div>
  </section>
);
